import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppConfig } from './app/Shared/app-config.inject';
import { registerLicense } from '@syncfusion/ej2-base';

const requestOrigin = window.location.origin;
if (environment.production) {
  enableProdMode();
}

function bootstrapApp() {
  const req = new XMLHttpRequest();

  req.addEventListener('error', (res: any) => {
    console.log('Error: ', res);
  });

  //to auto login if user session already exists --End--
  req.addEventListener('load', (res: any) => {
    let appConfig = JSON.parse(res.currentTarget.response);
    environment.syncfusionKey = appConfig.syncfusionKey;
    environment.apiBaseUrl = appConfig.apiBaseUrl;
    environment.production = appConfig.production;
    environment.paymentMaxWaitTime = appConfig.paymentMaxWaitTime;
    environment.paymentGetCCTStatusInterval = appConfig.paymentGetCCTStatusInterval;
    registerLicense(environment.syncfusionKey);
    const loginRequest = {
      scopes: ['']
    }

    environment.apiBaseUrl = requestOrigin + "/api";
    console.log("baseURL = ", environment.apiBaseUrl);
    console.log('config', appConfig);

    const LOCK_KEY = 'my-app-tab-lock';
    const HEARTBEAT_KEY = 'my-app-tab-heartbeat';
    const ROUTE_KEY = 'my-app-tab-route';
    const WARNING_URL = '/assets/duplicate-tab-warning.html';
    const HEARTBEAT_INTERVAL = 2000;
    const STALE_THRESHOLD = 5000;

    const allowedDuplicateRoutes = ['/shopper/dashboard', '/shopper/print-notes', '/shopper/details', '/shopper/admission-fee',
      '/shopper/admission-ticket', '/shopper/void', '/shopper/reports']; 

    function normalizePath(path: string) {
      return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    }

    const currentPath = normalizePath(window.location.pathname);

    // Give each tab a unique ID and store in sessionStorage
    const trueTabId = `${Date.now()}-${Math.random()}`;
    if (!window.name || window.name.startsWith('DUPLICATE')) {
      window.name = `TAB-${trueTabId}`;
      sessionStorage.setItem('tab-id', trueTabId);
    }

    const tabId = sessionStorage.getItem('tab-id')!;
    const lockInfoRaw = localStorage.getItem(LOCK_KEY);
    const heartbeatRaw = localStorage.getItem(HEARTBEAT_KEY);
    const lockedRoute = localStorage.getItem(ROUTE_KEY);

    let isDuplicate = false;

    if (lockInfoRaw && heartbeatRaw && lockedRoute) {
      try {
        const lockInfo = JSON.parse(lockInfoRaw);
        const heartbeatTime = parseInt(heartbeatRaw, 10);
        const isStale = Date.now() - heartbeatTime > STALE_THRESHOLD;

        const lockedPath = normalizePath(lockedRoute);
        const isLockedRouteAllowed = allowedDuplicateRoutes.some(route => lockedPath.startsWith(route));
        const isCurrentRouteAllowed = allowedDuplicateRoutes.some(route => currentPath.startsWith(route));

        if (lockInfo.tabId !== tabId && !isStale) {
          if (!isCurrentRouteAllowed && !isLockedRouteAllowed) {
            isDuplicate = true;
          }
        }
      } catch (e) {
        console.error('Tab lock info parse error', e);
      }
    }

    if (isDuplicate) {
      window.location.href = WARNING_URL;
    } else {
      // Store current tab and route
      localStorage.setItem(LOCK_KEY, JSON.stringify({ tabId }));
      localStorage.setItem(HEARTBEAT_KEY, Date.now().toString());
      localStorage.setItem(ROUTE_KEY, currentPath);

      setInterval(() => {
        localStorage.setItem(HEARTBEAT_KEY, Date.now().toString());
        localStorage.setItem(ROUTE_KEY, normalizePath(window.location.pathname));
      }, HEARTBEAT_INTERVAL);

      window.addEventListener('beforeunload', () => {
        const currentLock = JSON.parse(localStorage.getItem(LOCK_KEY) || '{}');
        if (currentLock.tabId === tabId) {
          localStorage.removeItem(LOCK_KEY);
          localStorage.removeItem(HEARTBEAT_KEY);
          localStorage.removeItem(ROUTE_KEY);
        }
      });
    }

    platformBrowserDynamic([
      {
        provide: AppConfig, useValue: {
          ...appConfig
        }
      },
    ]).bootstrapModule(AppModule)
      .then(() => {
        if ('serviceWorker' in navigator && environment.production) {
          navigator.serviceWorker.register('/ngsw-worker.js');
        }
      })
      .catch(err => console.error(err));
  });

  req.open('GET', '/assets/config/config.json');
  req.send(null);
}

bootstrapApp();


